<template>
  <div class="check-work-body">
    <div class="d-left">
      <div class="el-tree-1">
        <el-tree
          ref="tree"
          :data="data"
          :props="defaultProps"
          :lazy="true"
          :load="getData"
          @node-click="handleNodeClick"
        >
        </el-tree>
      </div>
    </div>
    <div class="d-right">
      <div
        v-if="mode == 1 && params.pindex_id > 0"
        style="margin-bottom: 5px; margin-left: 8px"
      >
        <el-button @click="dialogRegion">添加区域</el-button>
        <el-button @click="dialogBuilding">添加大楼</el-button>
        <el-button @click="dialogUnit">添加单元</el-button>
        <el-button @click="dialogRoom(0)">添加房间</el-button>
        <!-- <el-button @click="dialogImport">批量导入房产</el-button> -->
      </div>
      <div v-if="mode == 2" style="margin-bottom: 5px; margin-left: 8px">
        <el-button @click="saveRegion">绑定</el-button>
        <el-button @click="goBack">返回</el-button>
      </div>
      <el-card class="box-card" v-if="mode == 1">
        <el-form ref="from" :model="params" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="名称">
                <el-input
                  v-model="params.keyword"
                  placeholder="请输入区域/大楼/单元/房间名称"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item>
                <el-button
                  type="primary"
                  plain
                  icon="el-icon-search"
                  @click="search"
                >
                  搜索
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <div style="color: red; margin-left: 8px; margin-top: 8px">
        <span>当前房产：{{ houseName }}</span>
        <span style="margin-left: 8px">当前选中区域：{{ regionName }}</span>
      </div>
      <div v-if="mode == 1">
        <el-table
          key="tab01"
          class="box-table"
          height="600"
          :data="houseInfos"
          border
          style="width: 100%"
        >
          <el-table-column prop="ancestor_name" label="房产名称" />
          <el-table-column prop="type" label="类型" />
          <el-table-column label="操作">
            <template slot-scope="data">
              <el-button
                v-if="
                  data.row.area_id == data.row.house_id &&
                  data.row.type != 'room' &&
                  data.row.type != 'project'
                "
                type="text"
                icon="el-icon-setting"
                @click="changeModeRegion(data.row)"
              >
                移入房产
              </el-button>
              <el-button
                v-if="data.row.deepest_node == 1"
                type="text"
                icon="el-icon-setting"
                @click="dialogRoom(data.row.erp_house_id)"
              >
                修改房产
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="mode == 2">
        <el-table
          key="tab02"
          class="box-table"
          height="600"
          :data="list"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="ancestor_name" label="房产名称" />
          <el-table-column prop="type" label="类型" />
        </el-table>
      </div>
    </div>
    <Modal
      v-model="dialogRegionButton"
      ok-text="保存"
      width="600"
      :loading="loadingModal"
      :mask-closable="false"
      :mask="false"
      title="添加区域"
      @on-ok="addRegion"
    >
      <div>
        <el-form
          ref="from"
          :model="regionModel"
          label-width="auto"
          size="medium"
        >
          <el-form-item label="区域名称" prop="name">
            <el-input v-model="regionModel.name" placeholder="请输入区域名称" />
          </el-form-item>
        </el-form>
      </div>
    </Modal>

    <Modal
      v-model="dialogBuildingButton"
      ok-text="保存"
      width="600"
      :loading="loadingModal"
      :mask-closable="false"
      :mask="false"
      title="添加大楼"
      @on-ok="addBuilding"
    >
      <div>
        <el-form
          ref="from"
          :model="buildingModel"
          label-width="auto"
          size="medium"
        >
          <el-form-item label="大楼名称" prop="name">
            <el-input
              v-model="buildingModel.name"
              placeholder="请输入大楼名称"
            />
          </el-form-item>
          <el-form-item label="区域" prop="name">
            <el-select
              v-model="buildingModel.regionId"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="可搜索区域名称"
              :remote-method="searchRegion"
            >
              <el-option
                v-for="item in regionList"
                :key="item.house_id"
                :label="item.ancestor_name"
                :value="item.house_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </Modal>

    <Modal
      v-model="dialogUnitButton"
      ok-text="保存"
      width="600"
      :loading="loadingModal"
      :mask-closable="false"
      :mask="false"
      title="添加单元"
      @on-ok="addUnit"
    >
      <div>
        <el-form ref="from" :model="unitModel" label-width="auto" size="medium">
          <el-form-item label="单元名称" prop="name">
            <el-input v-model="unitModel.name" placeholder="请输入单元名称" />
          </el-form-item>
          <el-form-item label="大楼" prop="name">
            <el-select
              v-model="unitModel.buildingId"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="可搜索大楼名称"
              :remote-method="searchBuilding"
            >
              <el-option
                v-for="item in buildingList"
                :key="item.house_id"
                :label="item.ancestor_name"
                :value="item.house_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </Modal>
    <Modal
      v-model="dialogRoomButton"
      ok-text="保存"
      width="800"
      title="添加/编辑房间"
      @on-ok="addRoom"
    >
      <div>
        <el-form
          ref="from"
          label-width="80px"
          :model="roomModel"
          :rules="rules"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="选择项目" prop="pindex_id">
                <el-select
                  v-model="roomModel.pindex_id"
                  filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in pindexList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="选择类型" prop="type">
                <el-select v-model="roomModel.type" placeholder="请选择类型">
                  <el-option label="住宅" value="1"></el-option>
                  <el-option label="车位" value="2"></el-option>
                  <el-option label="储藏室" value="3"></el-option>
                  <el-option label="商铺" value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 住宅 -->
          <div v-if="roomModel.type == 1" prop="name">
            <el-form-item label="房间">
              <el-input
                v-model="roomModel.name"
                placeholder="填写房间"
              ></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="8">
                <el-form-item label="建筑面积">
                  <el-input
                    v-model="roomModel.area"
                    placeholder="填写建筑面积"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="套内面积">
                  <el-input
                    v-model="roomModel.dwelling_space"
                    placeholder="填写套内面积"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="计费面积" prop="charging">
                  <el-input
                    v-model="roomModel.charging"
                    placeholder="请填写计费面积"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="花园面积">
                  <el-input
                    v-model="roomModel.garden"
                    placeholder="填写花园面积"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="分摊面积">
                  <el-input
                    v-model="roomModel.share"
                    placeholder="填写分摊面积"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="区域" prop="regionId">
                  <el-select
                    v-model="roomModel.regionId"
                    filterable
                    remote
                    clearable
                    reserve-keyword
                    placeholder="可搜索区域名称"
                    :remote-method="searchRegion"
                  >
                    <el-option
                      v-for="item in regionList"
                      :key="item.house_id"
                      :label="item.ancestor_name"
                      :value="item.house_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="大楼">
                  <el-select
                    v-model="roomModel.buildingId"
                    filterable
                    remote
                    clearable
                    reserve-keyword
                    placeholder="可搜索大楼名称"
                    :remote-method="searchBuilding"
                  >
                    <el-option
                      v-for="item in buildingList"
                      :key="item.house_id"
                      :label="item.ancestor_name"
                      :value="item.house_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="单元" prop="unitId">
                  <el-select
                    v-model="roomModel.unitId"
                    filterable
                    remote
                    clearable
                    reserve-keyword
                    placeholder="可搜索单元名称"
                    :remote-method="searchUnit"
                  >
                    <el-option
                      v-for="item in unitList"
                      :key="item.house_id"
                      :label="item.ancestor_name"
                      :value="item.house_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="楼层" prop="floor">
                  <el-input
                    v-model="roomModel.floor"
                    placeholder="请填写楼层"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!-- 车位 -->
          <div v-if="roomModel.type == 2" prop="name">
            <el-form-item label="车位">
              <el-input
                v-model="roomModel.name"
                placeholder="填写车位"
              ></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="8">
                <el-form-item label="计费面积" prop="charging">
                  <el-input
                    v-model="roomModel.charging"
                    placeholder="请填写计费面积"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="停车场" prop="regionId">
                  <el-select
                    v-model="roomModel.regionId"
                    filterable
                    remote
                    clearable
                    reserve-keyword
                    placeholder="可搜索停车场名称"
                    :remote-method="searchRegion"
                  >
                    <el-option
                      v-for="item in regionList"
                      :key="item.house_id"
                      :label="item.ancestor_name"
                      :value="item.house_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="车区编号">
                  <el-select
                    v-model="roomModel.buildingId"
                    filterable
                    remote
                    clearable
                    reserve-keyword
                    placeholder="可搜索车区编号名称"
                    :remote-method="searchBuilding"
                  >
                    <el-option
                      v-for="item in buildingList"
                      :key="item.house_id"
                      :label="item.ancestor_name"
                      :value="item.house_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!-- 储藏室 -->
          <div v-if="roomModel.type == 3" prop="name">
            <el-form-item label="储藏室">
              <el-input
                v-model="roomModel.name"
                placeholder="填写储藏室编号"
              ></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="计费面积" prop="charging">
                  <el-input
                    v-model="roomModel.charging"
                    placeholder="请填写计费面积"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="区域" prop="regionId">
                  <el-select
                    v-model="roomModel.regionId"
                    filterable
                    remote
                    clearable
                    reserve-keyword
                    placeholder="可搜索区域名称"
                    :remote-method="searchRegion"
                  >
                    <el-option
                      v-for="item in regionList"
                      :key="item.house_id"
                      :label="item.ancestor_name"
                      :value="item.house_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="大楼">
                  <el-select
                    v-model="roomModel.buildingId"
                    filterable
                    remote
                    clearable
                    reserve-keyword
                    placeholder="可搜索大楼名称"
                    :remote-method="searchBuilding"
                  >
                    <el-option
                      v-for="item in buildingList"
                      :key="item.house_id"
                      :label="item.ancestor_name"
                      :value="item.house_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="单元">
                  <el-select
                    v-model="roomModel.unitId"
                    filterable
                    remote
                    clearable
                    reserve-keyword
                    placeholder="可搜索单元名称"
                    :remote-method="searchUnit"
                  >
                    <el-option
                      v-for="item in unitList"
                      :key="item.house_id"
                      :label="item.ancestor_name"
                      :value="item.house_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!-- 商铺 -->
          <div v-if="roomModel.type == 4">
            <el-form-item label="商铺" prop="name">
              <el-input
                v-model="roomModel.name"
                placeholder="填写商铺"
              ></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="8">
                <el-form-item label="楼层" prop="floor">
                  <el-input v-model="roomModel.floor" placeholder="填写楼层" />
                </el-form-item>
              </el-col>
              <el-col :span="8" prop="charging">
                <el-form-item label="计费面积">
                  <el-input
                    v-model="roomModel.charging"
                    placeholder="请填写计费面积"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="分摊面积">
                  <el-input
                    v-model="roomModel.share"
                    placeholder="填写分摊面积"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="区域" prop="regionId">
                  <el-select
                    v-model="roomModel.regionId"
                    filterable
                    remote
                    clearable
                    reserve-keyword
                    placeholder="可搜索区域名称"
                    :remote-method="searchRegion"
                  >
                    <el-option
                      v-for="item in regionList"
                      :key="item.house_id"
                      :label="item.ancestor_name"
                      :value="item.house_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="大楼">
                  <el-select
                    v-model="roomModel.buildingId"
                    filterable
                    remote
                    clearable
                    reserve-keyword
                    placeholder="可搜索大楼名称"
                    :remote-method="searchBuilding"
                  >
                    <el-option
                      v-for="item in buildingList"
                      :key="item.house_id"
                      :label="item.ancestor_name"
                      :value="item.house_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="单元">
                  <el-select
                    v-model="roomModel.unitId"
                    filterable
                    remote
                    clearable
                    reserve-keyword
                    placeholder="可搜索单元名称"
                    :remote-method="searchUnit"
                  >
                    <el-option
                      v-for="item in unitList"
                      :key="item.house_id"
                      :label="item.ancestor_name"
                      :value="item.house_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
    </Modal>
    <Modal
      v-model="dialogImportButton"
      ok-text="导入"
      width="600"
      :loading="loadingModal"
      :mask-closable="false"
      :mask="false"
      title="批量导入"
      @on-ok="addUnit"
    >
      <el-button type="primary" class="texts" @click="download">
        下载excel模板文件
      </el-button>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "HouseManage",
  data() {
    return {
      data: [],
      params: {
        keyword: "",
        houseId: "",
        pindex_id: "",
      },
      houseInfos: [],
      defaultProps: {
        label: "name",
        value: "id",
      },
      regionId: "", // 区域Id
      houseName: "",
      regionName: "",
      mode: 1,
      list: [],
      multipleSelection: [],
      pindexName: "",
      dialogRegionButton: false,
      loadingModal: false,
      rules: {
        name: [
          { required: true, message: "请填写房号/车位号", trigger: "blur" },
        ],
        pindex_id: [{ required: true, message: "请选择项目", trigger: "blur" }],
        type: [{ required: true, message: "请选择房间类型", trigger: "blur" }],
        regionId: [
          { required: true, message: "请选择区域/停车场", trigger: "blur" },
        ],
        floor: [{ required: true, message: "请填写楼层", trigger: "blur" }],
        charging: [
          { required: true, message: "请填写计费面积", trigger: "blur" },
        ],
      },
      regionModel: {
        name: "",
        pindex_id: "",
      },
      dialogBuildingButton: false,
      buildingModel: {
        pindex_id: "",
        name: "",
        regionId: "",
      },
      regionList: [],
      dialogUnitButton: false,
      unitModel: {
        pindex_id: "",
        name: "",
        buildingId: "",
      },
      buildingList: [],
      roomModel: {
        id: "",
        pindex_id: "",
        name: "",
        gender: "",
        type: "",
        area: "",
        dwelling_space: "",
        charging: "",
        garden: "",
        share: "",
        regionId: "",
        buildingId: "",
        unitId: "",
        floor: "",
      },
      dialogRoomButton: false,
      pindexList: [],
      unitList: [],
      dialogImportButton: false,
    };
  },
  mounted() {
    this.getProjectList();
    this.searchRegion("");
    this.searchBuilding("");
    this.searchUnit("");
  },
  watch: {
    "params.houseId"(n) {
      this.search();
    },
    "params.pindex_id"(n) {
      this.search();
      this.searchRegion("");
      this.searchBuilding("");
      this.searchUnit("");
    },
  },
  methods: {
    // 获得自己名下的所有项目
    getProjectList() {
      this.$myhttp
        .get("admin/common/pindex", {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.data = backdata.data.data.map((item) => {
              return {
                name: item.name,
                id: item.id,
                region: 0,
                type: "project",
                pindex_id: item.id,
                superior: "0",
                projectId: item.id,
              };
            });
            this.pindexList = backdata.data.data.map((item) => {
              return {
                name: item.name,
                id: item.id,
              };
            });
          } else {
            this.$message.error(backdata.data.message);
          }
        });
    },
    //节点下面的数据
    getData(node, resolve) {
      var region_id = node.data.id;
      setTimeout(() => {
        if (region_id == "" || region_id == undefined) {
          return false;
        }
        //加载
        node.data.region_id = region_id;
        node.data &&
          this.$myhttp
            .post("admin/common/getbindingArrs", node.data, {
              "Content-Type": "application/json",
            })
            .then((backdata) => {
              // 异步执行成功后
              // _this.defaultcheckedkeys =  _this.arr;
              return resolve(backdata.data);
            });
      }, 300);
    },
    // 处理房产树点击事件
    handleNodeClick(data) {
      if (this.mode == 1) {
        if (data.type == "project") {
          this.params.pindex_id = data.id;
          this.params.houseId = "";
          this.houseName = data.name;
          this.pindexName = data.name;
          this.roomModel.pindex_id = data.id;
        } else if (data.type == "room") {
        } else {
          this.params.pindex_id = data.erp_pindex_id;
          this.params.houseId = data.house_id;
          this.houseName = data.ancestor_name;
        }
        if (
          data.area_id == data.house_id &&
          data.type != "room" &&
          data.type != "project"
        ) {
          this.regionId = data.house_id;
          this.buildingModel.regionId = data.house_id;
          this.regionName = data.house_name;
        }
      } else if (this.mode == 2) {
        this.houseName = data.ancestor_name;
        this.search2();
      }
    },
    // 列表
    search() {
      if (this.params.pindex_id == "") {
        return false;
      }
      this.$myhttp
        .post("admin/house/houseList", this.params, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.houseInfos = backdata.data.data;
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    handleSelectionChange(row) {
      this.multipleSelection = row;
    },
    changeModeRegion(row) {
      this.regionId = row.house_id;
      this.regionName = row.house_name;
      this.mode = 2;
    },
    search2() {
      if (this.params.pindex_id == "") {
        return false;
      }
      this.$myhttp
        .post(
          "admin/house/allHouseList",
          { pindex_id: this.params.pindex_id, houseName: this.houseName },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.list = backdata.data.data;
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 移除
    del() {
      let data = [];
      if (this.list.length == this.multipleSelection.length) {
        this.list = [];
        this.multipleSelection = [];
      } else {
        this.list.map((req) => {
          let bool = true;
          this.multipleSelection.map((reqs) => {
            if (req.house_id == reqs.house_id) {
              bool = false;
            }
          });
          if (bool) {
            data.push(req);
          }
        });
      }
      this.list = data;
    },
    goBack() {
      this.mode = 1;
    },
    saveRegion() {
      let pindex_id = this.params.pindex_id;
      if (pindex_id == "" || pindex_id == 0) {
        return false;
      }
      let houseIds = [];
      this.multipleSelection.map((req) => {
        houseIds.push(req.house_id);
      });
      let regionId = this.regionId;
      let regionName = this.regionName;
      let pindexName = this.pindexName;
      this.$myhttp
        .post(
          "admin/house/saveRegion",
          { pindex_id, houseIds, regionId, regionName, pindexName },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.data = [];
            this.getProjectList();
            this.search2();
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    dialogRegion() {
      this.dialogRegionButton = true;
    },
    addRegion() {
      let pindex_id = this.params.pindex_id;
      if (pindex_id == "" || pindex_id == 0) {
        this.$message.error("请选择项目");
        this.loadingModals();
        return false;
      }
      this.regionModel.pindex_id = pindex_id;
      this.$myhttp
        .post("admin/house/addRegion", this.regionModel, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.loadingModals();
            this.$message.success(backdata.data.msg);
            this.data = [];
            this.getProjectList();
            this.dialogRegionButton = false;
          } else {
            this.loadingModals();
            this.$message.error(backdata.data.msg);
            this.dialogRegionButton = false;
          }
        })
        .catch((err) => {
          this.loadingModals();
          this.$message.error(err);
          this.dialogRegionButton = false;
        });
    },
    dialogBuilding() {
      this.dialogBuildingButton = true;
    },
    addBuilding() {
      let pindex_id = this.params.pindex_id;
      if (pindex_id == "" || pindex_id == 0) {
        this.$message.error("请选择项目");
        // this.loadingModals();
        return false;
      }
      if (
        this.buildingModel.regionId == "" ||
        this.buildingModel.regionId == 0
      ) {
        this.$message.error("请选择区域");
        return false;
      }
      this.buildingModel.pindex_id = pindex_id;
      this.$myhttp
        .post("admin/house/addBuilding", this.buildingModel, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.loadingModals();
            this.$message.success(backdata.data.msg);
            this.data = [];
            this.getProjectList();
            this.dialogBuildingButton = false;
          } else {
            this.loadingModals();
            this.$message.error(backdata.data.msg);
            this.dialogBuildingButton = false;
          }
        })
        .catch((err) => {
          this.loadingModals();
          this.$message.error(err);
          this.dialogRegionButton = false;
        });
    },
    loadingModals() {
      let _this = this;
      _this.loadingModal = false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10);
    },
    searchRegion(keyword) {
      let pindex_id = this.params.pindex_id;
      this.$myhttp
        .post(
          "admin/house/searchRegion",
          { pindex_id, keyword },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.regionList = backdata.data.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    searchBuilding(keyword) {
      let pindex_id = this.params.pindex_id;
      this.$myhttp
        .post(
          "admin/house/searchBuilding",
          { pindex_id, keyword },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.buildingList = backdata.data.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    dialogUnit() {
      this.dialogUnitButton = true;
    },
    addUnit() {
      let pindex_id = this.params.pindex_id;
      if (pindex_id == "" || pindex_id == 0) {
        this.$message.error("请选择项目");
        // this.loadingModals();
        return false;
      }
      if (this.unitModel.buildingId == "" || this.unitModel.buildingId == 0) {
        this.$message.error("请选择大楼");
        return false;
      }
      this.unitModel.pindex_id = pindex_id;
      this.$myhttp
        .post("admin/house/addUnit", this.unitModel, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.loadingModals();
            this.$message.success(backdata.data.msg);
            this.data = [];
            this.getProjectList();
            this.dialogBuildingButton = false;
          } else {
            this.loadingModals();
            this.$message.error(backdata.data.msg);
            this.dialogBuildingButton = false;
          }
        })
        .catch((err) => {
          this.loadingModals();
          this.$message.error(err);
          this.dialogRegionButton = false;
        });
    },
    dialogRoom(id) {
      this.dialogRoomButton = true;
      if (id != 0) {
        this.viewRoom(id);
      } else {
        this.roomModel = {
          id: "",
          pindex_id: "",
          name: "",
          gender: "",
          type: "",
          area: "",
          dwelling_space: "",
          charging: "",
          garden: "",
          share: "",
          regionId: "",
          buildingId: "",
          unitId: "",
          floor: "",
        };
      }
    },
    searchUnit(keyword) {
      let pindex_id = this.params.pindex_id;
      this.$myhttp
        .post(
          "admin/house/searchUnit",
          { pindex_id, keyword },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.unitList = backdata.data.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    addRoom() {
      this.$refs["from"].validate((valid) => {
        if (valid) {
          this.$myhttp
            .post("admin/house/addRoom", this.roomModel, {
              "Content-Type": "application/json",
            })
            .then((backdata) => {
              if (backdata.data.code == 200) {
                this.loadingModals();
                this.$message.success(backdata.data.msg);
                this.data = [];
                this.getProjectList();
                this.search();
                this.dialogRoomButton = false;
              } else {
                this.loadingModals();
                this.$message.error(backdata.data.msg);
                this.dialogRoomButton = false;
              }
            })
            .catch((err) => {
              this.loadingModals();
              this.$message.error(err);
              this.dialogRoomButton = false;
            });
        } else {
          this.loadingModals();
          return false;
        }
      });
    },
    viewRoom(it) {
      this.$myhttp
        .post(
          "admin/house/viewRoom",
          { id: it },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.roomModel = backdata.data.data;
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    dialogImport() {
      this.dialogImportButton = true;
    },
    //下载模板
    download() {
      var url = this.$myhttp.defaults.baseURL + "/excel/" + "数据导入模板.xls";
      window.open(url);
    },
  },
};
</script>

<style>
.d-left {
  float: left;
  width: 15%;
  border-right: 1px solid #eee;
  padding-right: 10px;
}
.el-tree-1 {
  overflow-y: scroll;
  height: 100vh;
  width: 100%;
}
.d-right {
  float: right;
  width: 84%;
  height: 100vh;
}
.check-work-body {
  padding: 10px;
  width: 100%;
}
.box-card {
  width: 100%;
  margin-top: 8px;
  margin-left: 8px;
}
.box-table {
  margin-top: 8px;
  margin-left: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/Project/HouseManage.vue